import { createAction, props } from '@ngrx/store';
import { ConsultationEntity } from './consultation.models';
import {
  LoadType,
  NewConsultationDTO,
  UpdateConsultationDTO
} from '@care-portals/api-interfaces';

export const loadConsultations = createAction(
  '[Consultation] Load Consultations',
  props<{ loadType: LoadType; filters: any }>()
);

export const loadConsultationsSuccess = createAction(
  '[Consultation] Load Consultations Success',
  props<{ consultations: ConsultationEntity[]; loadType: LoadType }>()
);

export const loadConsultationsFailure = createAction(
  '[Consultation] Load Consultations Failure',
  props<{ error: any }>()
);

export const saveConsultation = createAction(
  '[Consultation] Save Consultation',
  props<{ consultation: NewConsultationDTO }>()
);

export const saveConsultationSuccess = createAction(
  '[Consultation] Save Consultation Success',
  props<{ consultation: ConsultationEntity }>()
);

export const saveConsultationFailure = createAction(
  '[Consultation] Save Consultation Failure',
  props<{ error: any }>()
);

export const updateConsultation = createAction(
  '[Consultation] Update Consultation',
  props<{ id: string; consultation: UpdateConsultationDTO, callback?: () => void }>()
);

export const updateConsultationSuccess = createAction(
  '[Consultation] Update Consultation Success',
  props<{ consultation: ConsultationEntity, callback?: () => void }>()
);

export const updateConsultationFailure = createAction(
  '[Consultation] Update Consultation Failure',
  props<{ error: any }>()
);

export const setCurrentConsultation = createAction(
  '[Consultation] Set Current Consultation',
  props<{ id: string }>()
);

export const clearNotification = createAction(
  '[Consultation] Clear Notification',
  props<{ consultation: ConsultationEntity }>()
);

export const resetConsultations = createAction(
  '[Consultation] Reset Consultations'
);
